<template>
  <div>
    <HeaderBar>
      <v-icon slot="icon">people_outline</v-icon>
      Employees
     <template slot="buttons">
        <router-link :to="{ name: 'hr' }">
          Back to Team
        </router-link>
      </template>
    </HeaderBar>

    <div v-if="haveEmployee">
      <div fluid id="dashboard-container">
        <EmployeeDetailForClient v-if="user.role == 'client'">
        </EmployeeDetailForClient>

        <EmployeeDetailForManager v-if="user.managerOrHigher" :user="user">
        </EmployeeDetailForManager>
      </div>
    </div>

    <div v-else-if="refused" class="pa-3">
      <p class="subtle">This employee is not currently assigned to your locations.</p>
    </div>

    <div v-else-if="loadFailed" class="pa-3">
      <p class="subtle">This employee could not be loaded.</p>
    </div>

    <div v-else>
      <v-progress-linear indeterminate></v-progress-linear>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import HeaderBar from '@/components/base/header-bar.vue'
import EmployeeDetailForClient from '@/components/hr/employee-detail-for-client.vue'
import EmployeeDetailForManager from '@/components/hr/employee-detail-for-manager.vue'

export default {
  components: {
    HeaderBar,
    EmployeeDetailForClient,
    EmployeeDetailForManager,
  },
  created () {
    // this.$store.dispatch('employees/clearDetailed')

    // Don't re-fetch on every load. This is because if we already have an employee
    // in the store we might be navigating via the tabs on this page - in which
    // case we don't want to keep fetching this employee.
    if (this.detailedEmployee &&
        this.detailedEmployee.id === parseInt(this.$route.params.employeeId)
      ) {
      this.haveEmployee = true
      return
    }

    this.apiCallPending = true
    this.$store.dispatch('employees/getEmployee', this.$route.params.employeeId)
      .then(() => {
        this.haveEmployee = true
      })
      .catch(error => {
        // A client may open only employees currently assigned to their
        // locations; Billing, Cancelled Shifts and past calendar shifts still
        // link to past workers.
        if (error && error.response && error.response.status === 403) {
          this.refused = true
        } else {
          this.loadFailed = true
        }
      })
      .finally(() => {
        this.apiCallPending = false
      })
  },
  computed: {
    ...mapState('userAuth', [
      'user'
    ]),
    ...mapState('employees', [
      'detailedEmployee'
    ]),
    employee () {
      return this.detailedEmployee && this.detailedEmployee.id
    },
  },
  data: function() {
    return {
      haveEmployee: false,
      apiCallPending: false,
      refused: false,
      loadFailed: false,
    }
  },
}
</script>
